import React from 'react';
import { useInfiniteQuery } from "react-query";
import Configuration from "../config/Configuration";
import axios from 'axios';
const SERVER = Configuration.BASE_SERVER_URL;

const fetchUserPosts = async ({ token, username, pageParam, limit }) => {
//   let posts = await axios.get(SERVER + "/api/profile/" + username + "/posts");

  let url = `${SERVER}/api/profile/${username}/posts?page=${pageParam}&limit=${limit}`;
  let headers = { headers: { Authorization: `Bearer ${token}` } };
  let res = await axios.get(url, headers);
  return res.data;
};

export default ({token, limit = 10, username}) => {
  return useInfiniteQuery(
    ["profile", token, username],
    ({ pageParam = 1 }) => fetchUserPosts({token, pageParam, limit, username}),
    {
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage.posts.length == limit) {
          return allPages.length +  1;
        } else {
          return undefined;
        }
      },
    }
  );
};
